import PropTypes from 'prop-types';
import { useState } from 'react';
import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import { toast } from 'react-toastify'
import Iconify from '../../../components/iconify/Iconify'
import { trackerDelete } from '../../../services/trackerService';

TimeHistoryDeleteButton.propTypes = {
    trackerId: PropTypes.number.isRequired,
    fetchTimeline: PropTypes.any
}
function TimeHistoryDeleteButton({ trackerId, fetchTimeline }) {
    const [openDialog, setOpenDialog] = useState(false);

    const handleDialogOpen = () => setOpenDialog(true);
    const handleDialogClose = () => setOpenDialog(false);

    const handleDelete = async () => {
        try {
            // Delete Function
            await trackerDelete(trackerId)
            fetchTimeline()
            toast.success('Successfully deleted a time entry')
            handleDialogClose()
        } catch (error) {
            toast.error('Error while deleting')
            console.error(error)
            // handle error
        }
    };
    return (
        <>
            <Iconify icon={'gridicons:trash'} style={{ color: "#2065D1", cursor: "pointer" }} onClick={handleDialogOpen} />
            <Dialog
                open={openDialog}
                onClose={handleDialogClose}
                aria-labelledby="delete-dialog-title"
            >
                <DialogTitle id="delete-dialog-title">
                    {"Are you sure you want to delete this?"}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleDialogClose}>Cancel</Button>
                    <Button onClick={handleDelete}>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default TimeHistoryDeleteButton